import * as React from 'react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { SharedSurveyReport, surveyHelper, SurveyReportBuilder, SurveyReportDataSet } from '../../../amorg-common';
import { portalClientApi } from '../../../api/portalClientApi';
import { ToolBarButton, ToolBarContainer } from '../../../designSystem/compositeComponents/ButtonToolBar';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Divider } from '../../../designSystem/Divider';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../designSystem/PageHeader';
import { H1, H2 } from '../../../designSystem/typography/Heading';
import { EmployeePortalPageContext } from '../../_contexts/EmployeePortalPageContext';
import { EmployeePageWrapper } from '../../_pageWrappers/EmployeePageWrapper';
import { ReadOnlySegmentPanel } from '../../workplaceassessments/[activityId]/_components/tabs/_components/ReadOnlySegmentPanel';
import { SurveyReportPanel } from '../../workplaceassessments/[activityId]/_components/tabs/report/_components/SurveyReportPanel';

export function PortalSurveyReportPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <InnerPortalSurveyReportPage />
        </EmployeePageWrapper>
    );
}


type PageState = {
    publicReport: SharedSurveyReport | null,
    loading: boolean
};
function InnerPortalSurveyReportPage(): JSX.Element {

    const params = useParams<{ portalResourceId: string }>();

    const [state, setState] = useState<PageState>({
        publicReport: null,
        loading: true
    });

    const ctx = React.useContext(EmployeePortalPageContext);

    useEffect(() => {
        const getData = async () => {
            if(params.portalResourceId)
            {
                const publicReport = await portalClientApi.getPortalSurveyReport(params.portalResourceId);
                if(publicReport)
                {
                    setState({ publicReport: publicReport, loading: false });
                }
            }
        };
        getData();
    }, []);

    const hasQuestions = !state.loading && state.publicReport && surveyHelper.getAllSurveyQuestions(state.publicReport.survey).length > 0;

    const printRef = React.useRef(null);
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "Rapport"
    });

    const data:SurveyReportDataSet | null = React.useMemo(() => {
        if(!state.publicReport)
            return null;

        return SurveyReportBuilder.getDataFromSingleQuestionSummaryList(state.publicReport.survey, state.publicReport.data);
    }, [state.publicReport]);

    return (
        <>
            {!state.loading && state.publicReport &&
                <>
                <PageHeader narrow
                    headerContentsOverride={
                        <div>
                            <H1 color="gray">Rapport</H1>
                            <H2>{state.publicReport.activityTitle}</H2>
                        </div>
                    }
                    buttons={
                        <ToolBarContainer>
                            <ToolBarButton
                                icon='interface_actions_print'
                                tooltip= 'Print'
                                variant= 'text'
                                onClick={printFn} />
                        </ToolBarContainer>
                    } />
                </>
            }

            <SingleColumnLayout narrow>
                <>
                    {state.loading &&
                        <LoadingPageOverlay loading={state.loading} />
                    }

                </>
                <>
                <Flex flexDirection='column' gap={16}>
                    {!state.loading && state.publicReport === null &&
                        <p>Det valgte link er ugyldigt, eller ikke længere tilgængeligt. Kontakt din arbejdsmiljøgruppe.</p>
                    }
                    {!state.loading && state.publicReport && hasQuestions &&
                    <Flex flexDirection='column' gap={16}>
                        <H2>Segmenter</H2>
                        <ReadOnlySegmentPanel segmentLists={state.publicReport.segmentFilter} lockedView='pills' />
                    </Flex>
                    }
                </Flex>
                
                <Divider />

                <Flex flexDirection='column' gap={16}>

                    {state.loading &&
                        <LoadingPageOverlay loading={state.loading} />
                    }
                    {!state.loading && state.publicReport && !hasQuestions &&
                        <p>Spørgeskemaet indeholder ikke spørgsmål</p>
                    }

                    {!state.loading && state.publicReport && hasQuestions && data &&
                        <>
                            <SurveyReportPanel
                                siteId={ctx.user?.siteId || ''}
                                survey={state.publicReport.survey}
                                data={data}
                                segments={state.publicReport.segmentFilter}
                                showComments={false} />
                        </>
                    }

                </Flex>
                </>
            </SingleColumnLayout>
        </>
    );
}